var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChkGreenOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 22.5,
    rx: 2,
    fill: "#00BF9D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.4L5 11.4L6.4 10L9 12.6L15.6 6L17 7.4L9 15.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChkGreenOn);
export default __webpack_public_path__ + "static/media/chk_green_on.dab51bf93fb7bda8ff62af130f561aab.svg";
export { ForwardRef as ReactComponent };